export default "__VITE_ASSET__2JCn48Vk__"